import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RedirectIfLoggedIn = ({ element: Component, redirectTo, ...rest }) => {
  const { currentUser, isAdmin } = useAuth();

  if (currentUser && isAdmin()) {
    return <Navigate to={redirectTo} />;
  }

  if (currentUser && !isAdmin()) {
    return <Component {...rest} adminRequired={true} />;
  }

  return <Component {...rest} />;
};

export default RedirectIfLoggedIn;
